import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'eci-img-viewer',
  templateUrl: './img-viewer.component.html',
  styleUrls: ['./img-viewer.component.scss']
})
export class ImgViewerComponent implements OnInit {

  @Input() imgPreview: string;

  constructor() { }

  ngOnInit(): void {
  }

}
